import { useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { IonContent, IonPage, IonIcon } from '@ionic/react';
import { Storage } from '@capacitor/storage';
import { TranslateFlightRoutes } from '../defines/Functions';
import { ShowSwal } from '../defines/Functions';
import Countdown from "react-countdown";
import Auth from '../components/profile/modals/Auth';
import FlightCard from '../components/search/FlightCard';
import Step2 from '../components/reservation/flight/Step2';
import Step3 from '../components/reservation/flight/Step3';
import Step4 from '../components/reservation/flight/Step4';
import moment from 'jalali-moment';
import './FlightReservation.css';
import clockImg from '../assets/images/clock.svg';
import planeImg from '../assets/images/steps-plane.svg';
import passengersImg from '../assets/images/steps-passenger.svg';
import reviewImg from '../assets/images/steps-review.svg';
import paymentImg from '../assets/images/steps-payment.svg';
import ticketImg from '../assets/images/steps-ticket.svg';

const FlightReservation = (props: any) => {
    const flightData = props.location.state;
    const history = useHistory();
    const myRef = useRef<HTMLDivElement>(null);
    if (myRef.current) {
        var myRefCurrent = myRef.current;
    }
    const [step, setStep] = useState(2);
    const [isLogin, setIsLogin] = useState(false);
    const [passengers, setPassengers] = useState([]) as any;
    const [bookResult, setBookResult] = useState({}) as any;
    const ref = useRef(false);
    const getUserData = async () => {
        if (!ref.current) {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                setIsLogin(true);
            } else {
                setIsLogin(false);
            }
        }
        ref.current = true;
    }
    getUserData();
    const handleIsLoginCallback = (childData: boolean) => {
        setIsLogin(true);
    }
    const handleStepCallback = (childData: number) => {
        setStep(childData);
        myRefCurrent.scrollIntoView({ behavior: 'smooth' });
    }
    const handlePassengersCallback = (childData: any) => {
        setPassengers(childData);
    }
    const handleBookResultCallback = (childData: any) => {
        setBookResult(childData);
    }
    const onCountDownComplete = () => {
        const swalOptions = {
            html: '<div class="swal-html"><small><b>پایان زمان جستجو!</b></small><h6 class="title">مدت زمان اعتبار نتایج جستجو به اتمام رسید</h6><p>به منظور بروزرسانی قیمت ها لطفا جستجوی خود را از ابتدا انجام دهید.</p></div>',
            iconHtml: '<img src="' + clockImg + '" width="100" />',
            customClass: {
                container: ''
            },
            backdrop: true,
            allowOutsideClick: false,
            showConfirmButton: true,
            confirmButtonText: 'جستجوی مجدد',
            confirmButtonColor: '#333D79',
            showDenyButton: false,
            denyButtonText: '',
            denyButtonColor: '',
            isConfirmed: () => history.replace('/home'),
            isDenied: () => { }
        }
        ShowSwal(swalOptions);
    }
    return (
        <IonPage className="page-padding-top">
            <IonContent fullscreen>
                {flightData !== undefined &&
                    <div className="ion-padding flight-reservation-content" ref={myRef}>
                        <div className="reservation-steps">
                            <span className="active">
                                <IonIcon icon={planeImg} />
                            </span>
                            <span className={step >= 2 ? 'active' : ''}>
                                <IonIcon icon={passengersImg} />
                            </span>
                            <span className={step >= 3 ? 'active' : ''}>
                                <IonIcon icon={reviewImg} />
                            </span>
                            <span className={step >= 4 ? 'active' : ''}>
                                <IonIcon icon={paymentImg} />
                            </span>
                            <span className={step >= 5 ? 'active' : ''} >
                                <IonIcon icon={ticketImg} />
                            </span>
                        </div>
                        {step < 4 ? (
                            <>
                                <Countdown date={Date.now() + flightData.expireTime.current} onComplete={onCountDownComplete} className="reservation-countdown"></Countdown>
                                <small>اطلاعات پرواز  - {flightData.searchType === 'oneway' ? 'یک طرفه' : flightData.searchType === 'roundtrip' ? 'رفت و برگشت' : 'چند مسیره'}</small>
                                {flightData.searchType !== 'multiple' ?
                                    <>
                                        <div className="reservation-moving-date">
                                            تاریخ رفت :
                                            <b>{moment(flightData.flightDefines.all.routes[0].dates.departure).locale('fa').format('dddd DD MMMM YYYY')}</b>
                                        </div>
                                        {flightData.searchType === 'roundtrip' &&
                                            <div className="reservation-moving-date">
                                                تاریخ برگشت :
                                                <b>{moment(flightData.flightDefines.all.routes[0].dates.arrival).locale('fa').format('dddd DD MMMM YYYY')}</b>
                                            </div>
                                        }
                                    </>
                                    :
                                    flightData.flightDefines.all.routes.map((item: any, index: number) =>
                                        <div className="reservation-moving-date" key={"index" + index}>
                                            تاریخ {TranslateFlightRoutes(index + 1)} :
                                            <b>{moment(flightData.flightDefines.all.routes[0].dates.departure).locale('fa').format('dddd DD MMMM YYYY')}</b>
                                        </div>
                                    )
                                }
                                <FlightCard
                                    id={0}
                                    data={flightData.data}
                                    flightDefines={flightData.flightDefines}
                                    searchType=""
                                />
                            </>
                        ) : (
                            null
                        )}
                        {!isLogin ?
                            <>
                                <small className="ion-margin-bottom">
                                    <b>
                                        جهت ادامه فرایند خرید وارد حساب کاربری خود شوید و یا ثبت نام کنید.
                                    </b>
                                </small>
                                <Auth isLoginParentCallback={handleIsLoginCallback} />
                            </>
                            :
                            step === 2 ? (
                                <Step2
                                    data={flightData}
                                    stepParentCallback={handleStepCallback}
                                    passengersParentCallback={handlePassengersCallback}
                                />
                            ) : step === 3 ? (
                                <Step3
                                    data={flightData}
                                    stepParentCallback={handleStepCallback}
                                    passengers={passengers}
                                    bookResultParentCallback={handleBookResultCallback}
                                />
                            ) : step === 4 ? (
                                <Step4 bookResult={bookResult} />
                            ) : step === 5 ? (
                                null
                            ) : (
                                null
                            )}
                    </div>
                }
            </IonContent>
        </IonPage>
    );
};

export default FlightReservation;